(function () {
  if (window.__igReelsRuntimeInit) return;
  window.__igReelsRuntimeInit = true;
  var SESSION_CACHE_PREFIX = 'ig-reels-cache:';
  var SESSION_CACHE_TTL_MS = 15 * 60 * 1000; // 15 minutes

  function initFilmstrip(filmstrip) {
    if (filmstrip.__igReelsInit) return;
    filmstrip.__igReelsInit = true;

    // One continuous filmstrip: every reel is an equal card, whichever one
    // ends up centered in the scroll container is "active" — it plays,
    // gets the ambient glow, and owns the shared sound button. Replaces
    // the old model of one always-playing "featured" slot next to static
    // side cards that never did anything until clicked.
    var cards = Array.prototype.slice.call(filmstrip.querySelectorAll('[data-ig-reel-card]'));
    if (!cards.length) {
      initAutoFetch(filmstrip);
      return;
    }

    // Every other lookup in this closure is scoped to `filmstrip`, but the
    // sound button and the Prev/Next buttons are siblings of it rather
    // than descendants, so they need the section wrapper as their root.
    //
    // Bug this fixes: they were found with document.querySelector, which
    // always returns the FIRST match in the whole page regardless of which
    // instance this iteration is setting up. With the section placed twice
    // (or duplicated in the theme editor), every instance bound to the
    // first section's controls — so one click ran both instances'
    // handlers, and the second section's own buttons did nothing. The
    // sound button was worse than a dead control: placeSoundButton()
    // *moves* it with appendChild rather than cloning, so the second
    // instance would physically steal the button out of the first
    // section's active card.
    var section = filmstrip.closest('.ig-reels') || document;

    var soundButton = section.querySelector('[data-ig-reel-sound]');
    var playbackButton = section.querySelector('[data-ig-reel-playback]');
    var motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
    var playbackEnabled = !motionPreference.matches && !(navigator.connection && navigator.connection.saveData);
    var isVisible = false;
    var disposed = false;
    var cleanupCallbacks = [];
    var timeouts = new Set();
    var frames = new Set();

    function listen(target, type, callback, options) {
      target.addEventListener(type, callback, options);
      cleanupCallbacks.push(function () { target.removeEventListener(type, callback, options); });
    }

    function schedule(callback, delay) {
      var id = window.setTimeout(function () {
        timeouts.delete(id);
        if (!disposed) callback();
      }, delay);
      timeouts.add(id);
      return id;
    }

    function nextFrame(callback) {
      var id = window.requestAnimationFrame(function (timestamp) {
        frames.delete(id);
        if (!disposed) callback(timestamp);
      });
      frames.add(id);
      return id;
    }

    filmstrip.__igReelsDestroy = function () {
      disposed = true;
      cleanupCallbacks.forEach(function (cleanup) { cleanup(); });
      timeouts.forEach(function (id) { window.clearTimeout(id); });
      frames.forEach(function (id) { window.cancelAnimationFrame(id); });
      stopAmbientSampling();
      cards.forEach(function (card) {
        var video = videoFor(card);
        if (video) video.pause();
      });
    };

    // Position dots. Liquid renders one per reel block; if the auto-fetch
    // path has since replaced the cards with a different number of them,
    // the row would be silently wrong about how many reels exist — so it
    // is hidden rather than left lying, and everything else carries on.
    var dotsRow = section.querySelector('[data-ig-reels-dots]');
    var dots = dotsRow ? Array.prototype.slice.call(dotsRow.querySelectorAll('[data-ig-reels-dot]')) : [];
    if (dotsRow && dots.length !== cards.length) {
      dotsRow.hidden = true;
      dots = [];
    }

    function syncDots(index) {
      dots.forEach(function (dot, i) {
        var isOn = i === index;
        dot.classList.toggle('is-active', isOn);
        if (isOn) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
    }

    var activeIndex = 0;
    var currentVideo = null;
    var advancing = false; // guards against overlapping auto-advance calls

    function videoFor(card) {
      return card.querySelector('[data-ig-reel-video]');
    }

    function placeSoundButton(card) {
      // Keep buttons outside the post link so keyboard and screen-reader
      // users can operate them without nested interactive elements.
      [soundButton, playbackButton].forEach(function (button) {
        if (!button) return;
        button.hidden = !videoFor(card);
        card.appendChild(button);
      });
    }

    function canPlay() {
      return !disposed && playbackEnabled && isVisible && !document.hidden;
    }

    function requestVideoMetadata(index) {
      // Load only the active reel and the next reel. Loading metadata for
      // the entire filmstrip at once created ten simultaneous media requests
      // and could leave the active card waiting behind videos off screen.
      [index, (index + 1) % cards.length].forEach(function (cardIndex) {
        var card = cards[cardIndex];
        var video = videoFor(card);
        if (!video || video.dataset.metadataRequested) return;
        video.dataset.metadataRequested = 'true';
        video.preload = 'metadata';
        video.load();
      });
    }

    function syncPlaybackButton() {
      if (!playbackButton) return;
      var label = playbackEnabled ? playbackButton.dataset.i18nPause : playbackButton.dataset.i18nPlay;
      playbackButton.textContent = label || (playbackEnabled ? 'Pause video' : 'Play video');
      playbackButton.setAttribute('aria-label', playbackButton.textContent);
    }

    function syncPlayback() {
      syncPlaybackButton();
      if (!currentVideo) return;
      if (!canPlay()) {
        currentVideo.pause();
        stopAmbientSampling();
        return;
      }
      var video = currentVideo;
      video.play().then(function () {
        if (disposed || video !== currentVideo || !canPlay()) {
          video.pause();
          return;
        }
        if (!video.muted && video.volume === 0) fadeVolumeTo(video, UNMUTED_VOLUME, VOLUME_FADE_MS);
        startAmbientSampling();
      }).catch(function (error) {
        if (disposed || video !== currentVideo || error.name !== 'NotAllowedError') return;
        playbackEnabled = false;
        syncPlaybackButton();
      });
    }

    // Bug this fixes: unmuting used to just flip `.muted = false` directly,
    // which plays at whatever `.volume` a fresh <video> element defaults
    // to (1.0 — full volume) with zero ramp-up, so sound started as an
    // abrupt jolt right at max level. Capping the target below 1.0 and
    // ramping up to it over a fraction of a second reads as an
    // intentional "sound coming on" moment instead of a jump scare.
    // Applied both on the very first unmute (tryUnmute, below) and every
    // time a *new* reel becomes active while sound is already on
    // (setActive, above) — the latter matters just as much, since without
    // it every reel after the first would still snap straight to full
    // volume the moment it became active.
    var UNMUTED_VOLUME = 0.65;
    var VOLUME_FADE_MS = 350;

    function fadeVolumeTo(video, target, durationMs) {
      var startVolume = video.volume;
      var startTime = null;
      function step(timestamp) {
        // A card swapped out (paused/rewound) mid-fade shouldn't keep
        // driving its volume up in the background.
        if (video.paused) return;
        if (startTime === null) startTime = timestamp;
        var progress = Math.min((timestamp - startTime) / durationMs, 1);
        video.volume = startVolume + (target - startVolume) * progress;
        if (progress < 1) nextFrame(step);
      }
      nextFrame(step);
    }

    // Bug this fixes: a deactivated card's video was only ever paused —
    // never rewound. Its currentTime just sat wherever playback happened
    // to stop (e.g. a reel the visitor swiped away from partway through).
    // If that same card ever became active again later — auto-advance
    // wrapping back around past the last reel to the first, swiping back
    // to one already seen, anything — play() resumed it from that old
    // position instead of the start. When that leftover position was
    // near the end of the clip, it fired `ended` almost immediately,
    // which triggers handleEnded()'s auto-advance again, which could
    // cascade through several already-visited cards in a fast chain
    // (bounded only by handleEnded's 500ms cooldown) until it finally
    // reached a reel that had never been played before and so ran its
    // real, full length — exactly "keeps going through the reels, not
    // stopping until one finishes." Rewinding on deactivate means every
    // reel always starts from 0 the next time it becomes active, which
    // is also just the correct behavior for a reels-style UI regardless.
    function setActive(index) {
      if (disposed || index < 0 || index >= cards.length) return;
      var wasMuted = currentVideo ? currentVideo.muted : true;
      activeIndex = index;

      cards.forEach(function (card, i) {
        var video = videoFor(card);
        if (i === index) {
          card.classList.add('is-active');
          if (video) {
            video.muted = wasMuted;
            if (!wasMuted) {
              video.volume = 0;
            }
          }
        } else {
          card.classList.remove('is-active');
          if (video) {
            if (!video.paused) video.pause();
            // Guarded rather than assigned unconditionally: writing
            // currentTime counts as a seek even when the value is already
            // 0, and on a preload="metadata" video a seek can send the
            // browser back for the opening bytes it never kept. This runs
            // for every non-active card on every activation, so the
            // unguarded version was firing seven pointless seeks per
            // navigation — the reels that had never played got poked
            // repeatedly for no reason.
            if (video.currentTime !== 0) video.currentTime = 0;
          }
        }
      });

      currentVideo = videoFor(cards[index]);
      if (isVisible) requestVideoMetadata(index);
      placeSoundButton(cards[index]);
      syncDots(index);
      syncPlayback();
    }

    // Bug this fixes: card.scrollIntoView({ behavior: 'instant', ... })
    // used to do this centering. 'instant' was never part of the original
    // scrollIntoView spec — support for it varies by browser/version, and
    // where it's not recognized the call can silently no-op or fall back
    // to inconsistent behavior instead of throwing, so the miscentering
    // was easy to miss testing on any one browser. Computing the target
    // scrollLeft directly and setting it (or animating to it via
    // scrollTo(), which every evergreen browser supports identically)
    // removes that ambiguity entirely — this is exact math, not a hope
    // that a loosely-specified option does what it sounds like.
    function targetScrollLeftFor(card) {
      // getBoundingClientRect() + the filmstrip's own current scrollLeft,
      // rather than card.offsetLeft, so this is correct regardless of
      // which ancestor actually ends up as the card's offsetParent —
      // viewport-relative rects can't be thrown off by that.
      var filmstripRect = filmstrip.getBoundingClientRect();
      var cardRect = card.getBoundingClientRect();
      var cardCenterInScrollSpace = cardRect.left - filmstripRect.left + filmstrip.scrollLeft + cardRect.width / 2;
      var target = cardCenterInScrollSpace - filmstrip.clientWidth / 2;
      var maxScroll = filmstrip.scrollWidth - filmstrip.clientWidth;
      return Math.max(0, Math.min(target, maxScroll));
    }

    function centerCard(card, smooth) {
      var target = targetScrollLeftFor(card);
      if (smooth && !motionPreference.matches) {
        filmstrip.scrollTo({ left: target, behavior: 'smooth' });
      } else {
        filmstrip.scrollLeft = target;
      }
    }

    // A programmatic scrollTo()/scrollLeft write firing *while* a finger
    // is still mid-drag genuinely fights the touch gesture in most
    // mobile browsers. The only JS-driven recenters left (resize/load/
    // rAF, further down) check this first and skip themselves while the
    // visitor is actively touching the filmstrip.
    var userTouching = false;
    // Declared up here (rather than down by the IntersectionObserver that
    // sets it) since goToIndex, above the observer in this file, also
    // needs to clear it — var hoisting made that technically work either
    // way, but only by accident, so it's declared where it's first used.
    var pendingActivateTimer = null;
    listen(filmstrip,
      'touchstart',
      function () {
        userTouching = true;
      },
      { passive: true }
    );
    ['touchend', 'touchcancel'].forEach(function (evt) {
      listen(filmstrip,
        evt,
        function () {
          userTouching = false;
        },
        { passive: true }
      );
    });

    // Deliberately no post-swipe "recenter" pass here (there used to be
    // one, on both touchend and the scrollend event). A user-driven
    // swipe/drag is already brought to an exactly-centered rest position
    // by the browser's own native `scroll-snap-align: center` — that's
    // what CSS scroll-snap is *for*. Layering a JS-computed scrollTo() on
    // top of an already-correct native snap doesn't improve anything; it
    // only risks a visible micro-jump if it fires a beat before or after
    // the browser's own snap settles, which was a real contributor to
    // "buggy on the phone." JS now only ever drives the scroll position
    // for *programmatic* navigation (buttons/keyboard/auto-advance),
    // where there's no native gesture to trust instead.

    // Finds whichever card is *actually* nearest the filmstrip's visual
    // center right now, from real geometry — not from the cached
    // activeIndex, which can briefly lag behind a swipe until the
    // IntersectionObserver's debounce catches up. Prev/Next and arrow-key
    // navigation use this so pressing a button always acts on what the
    // visitor is actually looking at, even if they just finished
    // swiping a moment before. This is what fixes buttons/keys
    // occasionally "scrolling to the wrong place" right after a swipe.
    function nearestIndexToCenter() {
      var filmstripRect = filmstrip.getBoundingClientRect();
      var center = filmstripRect.left + filmstripRect.width / 2;
      var nearest = activeIndex;
      var nearestDistance = Infinity;
      cards.forEach(function (card, i) {
        var rect = card.getBoundingClientRect();
        var distance = Math.abs(rect.left + rect.width / 2 - center);
        if (distance < nearestDistance) {
          nearestDistance = distance;
          nearest = i;
        }
      });
      return nearest;
    }

    function goToIndex(index) {
      var wrapped = ((index % cards.length) + cards.length) % cards.length;
      var card = cards[wrapped];
      if (!card) return;
      // A pending observer activation (from a swipe that hasn't finished
      // its debounce yet) could otherwise fire right after this and
      // immediately override the navigation that was just requested.
      if (pendingActivateTimer) {
        window.clearTimeout(pendingActivateTimer);
        pendingActivateTimer = null;
      }
      // "Active" is a transform:scale() now, not a width/reflow change
      // (see the CSS), so scaling from the card's own center means its
      // scroll-snap center point never actually moves during the
      // transition — there's nothing to wait for, so centering and
      // activating can both just happen immediately, in either order.
      // Going forward off the last card lands on the first, which sits a
      // full filmstrip-width away — a smooth scroll for that reads as the
      // strip tearing across the screen on its own, not as navigation.
      // Any jump longer than half the strip is treated the same way: it
      // is a loop, so it cuts rather than travels. Adjacent moves, which
      // is what nearly every press actually is, still animate.
      var isLongJump = Math.abs(wrapped - activeIndex) > cards.length / 2;
      centerCard(card, !isLongJump);
      setActive(wrapped);
    }

    function handleEnded() {
      if (advancing || !canPlay()) return;
      var nextIndex = -1;
      for (var offset = 1; offset <= cards.length; offset++) {
        var candidateIndex = (activeIndex + offset) % cards.length;
        var candidate = videoFor(cards[candidateIndex]);
        if (candidate && !candidate.error) {
          nextIndex = candidateIndex;
          break;
        }
      }
      if (nextIndex === -1) return;
      advancing = true;
      goToIndex(nextIndex);
      schedule(function () {
        advancing = false;
      }, 500);
    }

    // Ambilight: the ambient glow used to just cycle through a fixed
    // red/purple/blue palette, unrelated to whatever's actually playing.
    // This samples the active video's own real average color onto a tiny
    // offscreen canvas a few times a second and feeds it into the glow's
    // gradient (as --glow-c1/2/3, see the CSS) — the halo now genuinely
    // matches the footage instead of an arbitrary cycle.
    var ambientCanvas = document.createElement('canvas');
    ambientCanvas.width = 16;
    ambientCanvas.height = 16;
    var ambientCtx = ambientCanvas.getContext && ambientCanvas.getContext('2d', { willReadFrequently: true });
    var ambientTimer = null;
    // Set once if canvas sampling ever throws (a tainted canvas from a
    // CORS restriction, most likely) so it stops trying instead of
    // throwing on every tick from then on — the CSS fallback colors
    // already declared on .ig-reel-card__glow take over cleanly either
    // way, so a visitor never sees anything broken, just the older
    // fixed-palette look.
    var ambientBroken = !ambientCtx;

    function rgbToHsl(r, g, b) {
      r /= 255;
      g /= 255;
      b /= 255;
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var h = 0;
      var s = 0;
      var l = (max + min) / 2;
      if (max !== min) {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
        else if (max === g) h = (b - r) / d + 2;
        else h = (r - g) / d + 4;
        h /= 6;
      }
      return [h * 360, s, l];
    }

    function hslToRgb(h, s, l) {
      h = ((h % 360) + 360) % 360;
      h /= 360;
      var r, g, b;
      if (s === 0) {
        r = g = b = l;
      } else {
        var hue2rgb = function (p, q, t) {
          if (t < 0) t += 1;
          if (t > 1) t -= 1;
          if (t < 1 / 6) return p + (q - p) * 6 * t;
          if (t < 1 / 2) return q;
          if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
          return p;
        };
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }
      return [Math.round(r * 255), Math.round(g * 255), Math.round(b * 255)];
    }

    function applyAmbientColor(r, g, b) {
      var card = cards[activeIndex];
      var glowEl = card ? card.querySelector('.ig-reel-card__glow') : null;
      if (!glowEl) return;

      var hsl = rgbToHsl(r, g, b);
      var hue = hsl[0];
      // Real shop footage is often dim/desaturated (concrete floors,
      // overcast daylight) — flooring the saturation and clamping
      // lightness into a visible band keeps the glow reading as a vivid
      // accent instead of a muddy gray smear, while the hue itself still
      // genuinely comes from the video rather than being invented.
      var sat = Math.max(hsl[1], 0.5);
      var light = Math.min(Math.max(hsl[2], 0.38), 0.58);

      var c1 = hslToRgb(hue, sat, light);
      var c2 = hslToRgb(hue + 25, sat, light);
      var c3 = hslToRgb(hue - 25, sat, light);

      glowEl.style.setProperty('--glow-c1', 'rgba(' + c1[0] + ', ' + c1[1] + ', ' + c1[2] + ', 0.68)');
      glowEl.style.setProperty('--glow-c2', 'rgba(' + c2[0] + ', ' + c2[1] + ', ' + c2[2] + ', 0.62)');
      glowEl.style.setProperty('--glow-c3', 'rgba(' + c3[0] + ', ' + c3[1] + ', ' + c3[2] + ', 0.58)');
    }

    function sampleAmbientColor() {
      if (ambientBroken || !currentVideo || currentVideo.paused || !canPlay()) return;
      if (currentVideo.readyState < 2 || !currentVideo.videoWidth) return;

      var data;
      try {
        ambientCtx.drawImage(currentVideo, 0, 0, ambientCanvas.width, ambientCanvas.height);
        data = ambientCtx.getImageData(0, 0, ambientCanvas.width, ambientCanvas.height).data;
      } catch (e) {
        ambientBroken = true;
        if (ambientTimer) window.clearInterval(ambientTimer);
        return;
      }

      var r = 0;
      var g = 0;
      var b = 0;
      var count = 0;
      for (var i = 0; i < data.length; i += 4) {
        r += data[i];
        g += data[i + 1];
        b += data[i + 2];
        count++;
      }
      applyAmbientColor(Math.round(r / count), Math.round(g / count), Math.round(b / count));
    }

    function startAmbientSampling() {
      if (ambientBroken || ambientTimer || motionPreference.matches || !canPlay()) return;
      // currentVideo is read live from the outer scope on every tick, so
      // one interval started once keeps working correctly across every
      // later active-card change — no need to restart it per card.
      sampleAmbientColor();
      ambientTimer = window.setInterval(sampleAmbientColor, 350);
    }

    function stopAmbientSampling() {
      if (ambientTimer) window.clearInterval(ambientTimer);
      ambientTimer = null;
    }

    cards.forEach(function (card) {
      var video = videoFor(card);
      if (!video) return;
      listen(video, 'ended', function () {
        if (video !== currentVideo || !canPlay()) return;
        if (cards.length < 2) {
          // Only one usable reel — just loop it in place.
          video.currentTime = 0;
          video.play().catch(function () {});
          return;
        }
        handleEnded();
      });
      // A broken/missing file should skip ahead instead of freezing the
      // filmstrip on a black card.
      listen(video, 'error', function () {
        card.removeAttribute('data-buffering');
        if (video === currentVideo) handleEnded();
      });

      // Live progress bar — the TikTok/Reels-style slim bar along the top
      // of the active card, filled from actual playback position.
      var progressFill = card.querySelector('[data-ig-reel-progress]');
      if (progressFill) {
        listen(video, 'timeupdate', function () {
          if (!video.duration) return;
          var pct = (video.currentTime / video.duration) * 100;
          progressFill.style.width = pct + '%';
        });
      }

      // Buffering indicator — only shows real stalls (readyState says
      // there isn't enough data to keep playing), never just "not yet
      // the active card," since inactive cards are paused, not buffering.
      listen(video, 'waiting', function () {
        if (video === currentVideo && canPlay()) {
          card.setAttribute('data-buffering', '');
          if (card.__bufferingTimeout) window.clearTimeout(card.__bufferingTimeout);
          card.__bufferingTimeout = schedule(function () {
            card.removeAttribute('data-buffering');
          }, 8000);
        }
      });
      ['playing', 'canplay', 'canplaythrough', 'loadeddata', 'pause', 'error'].forEach(function (evt) {
        listen(video, evt, function () {
          if (card.__bufferingTimeout) window.clearTimeout(card.__bufferingTimeout);
          card.__bufferingTimeout = null;
          card.removeAttribute('data-buffering');
        });
      });
    });

    // Keeps "active" in sync with whatever the visitor actually scrolls
    // to manually (swipe/drag), not just programmatic auto-advance — both
    // paths go through the same observer, so there's only one source of
    // truth for "which card is active" instead of two competing ones.
    //
    // Debounced on purpose: the active card's width now actually changes
    // (not just a transform:scale), which shifts every card after it in
    // the row as it grows/shrinks. That reflow can itself nudge a
    // neighboring card's intersection ratio across the 0.6 threshold
    // mid-transition, which without debouncing could re-trigger setActive
    // on the wrong card and flicker back and forth. Requiring a candidate
    // to still be the most recent one after a short pause means only the
    // card the scroll actually settles on wins.
    // Bug this fixes: nothing ever scrolled the filmstrip to actually
    // center card 0 on page load — its server-rendered `is-active` class
    // just happened to sit at whatever the browser's natural rest
    // position (scrollLeft: 0) was, which is the *start* of the row's own
    // centering padding, not a centered view of card 0. That mismatch
    // meant several cards could already be >=60% visible the instant the
    // observer below started watching them, and IntersectionObserver
    // fires an initial callback immediately for anything already
    // intersecting when observe() is called — so on some loads it would
    // immediately "activate" whichever later card happened to occupy
    // that accidental default scroll position, leaving card 0 sitting
    // small/inactive off to the left and a visibly empty gap where the
    // real active card should have been centered. Centering card 0 for
    // real (instantly, no animation, before anything observes anything)
    // makes the visual state match the logical one from the very first
    // frame, so the observer's initial fire correctly confirms card 0
    // instead of guessing wrong.
    centerCard(cards[0], false);

    // Belt-and-suspenders on top of the fix above: a web font finishing
    // its swap, or a poster image settling into its real dimensions, can
    // reflow the page slightly *after* this script's first run — enough
    // to throw off a centering calculation done a moment earlier against
    // not-yet-final layout. Re-running the same instant center once more
    // on the next frame, and again on the window's full 'load' event
    // (which only fires once every asset has actually finished), costs
    // nothing once things are already correct — it's the exact same math
    // landing on the exact same answer — and quietly corrects things on
    // the runs where they weren't.
    nextFrame(function () {
      if (userTouching) return;
      centerCard(cards[activeIndex], false);
    });
    listen(window,
      'load',
      function () {
        if (userTouching) return;
        centerCard(cards[activeIndex], false);
      },
      { once: true }
    );

    // Resizing the window (or rotating a device) changes the filmstrip's
    // own width, which changes what "centered" even means — without
    // this, the active card just drifts off-center after any resize and
    // stays that way until the next auto-advance happens to fix it.
    // Recomputed from real geometry (nearestIndexToCenter), not the
    // cached activeIndex, in case a resize lands right after a swipe the
    // observer hasn't finished debouncing yet.
    var resizeRecenterTimer = null;
    listen(window, 'resize', function () {
      if (resizeRecenterTimer) window.clearTimeout(resizeRecenterTimer);
      resizeRecenterTimer = schedule(function () {
        resizeRecenterTimer = null;
        if (userTouching) return;
        var idx = nearestIndexToCenter();
        setActive(idx);
        centerCard(cards[idx], false);
      }, 150);
    });

    // Bug this fixes (desktop-specific — worked fine on narrow mobile
    // viewports the whole time): this used to trust *which* card each
    // qualifying entry named as "the" newly-active one. On a wide desktop
    // layout, the filmstrip's own visible box is roughly 1200px while
    // cards are only ~280-340px — comfortably enough room for 3-4 cards
    // to *simultaneously* sit at >=60% visible with nothing being
    // scrolled at all. A narrow mobile viewport only ever fits about one
    // card in that zone, so this ambiguity never had a chance to surface
    // there. Whichever card happened to be last in a given entries batch
    // (not necessarily the one actually centered) would win and get
    // activated — reads as the filmstrip randomly switching reels on its
    // own. Now a qualifying entry is only ever a "something changed, go
    // check" signal; the actual decision always goes through
    // nearestIndexToCenter() — the same real-geometry source of truth
    // already used for Prev/Next — so it's never ambiguous which card is
    // genuinely centered, no matter how many happen to cross the raw
    // visibility threshold at once.
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          var anyQualifies = entries.some(function (entry) {
            return entry.isIntersecting && entry.intersectionRatio >= 0.6;
          });
          if (!anyQualifies) return;
          if (pendingActivateTimer) window.clearTimeout(pendingActivateTimer);
          // No follow-up centerCard() here on purpose — this path only
          // ever fires from a real user swipe/drag, which native CSS
          // scroll-snap has *already* brought to an exactly-centered
          // rest position by the time this settles. All this needs to
          // do is update which video plays and how cards look; forcing
          // another scroll on top of an already-correct native one is
          // exactly what used to cause a visible micro-jump.
          pendingActivateTimer = schedule(function () {
            pendingActivateTimer = null;
            var idx = nearestIndexToCenter();
            if (idx !== activeIndex) setActive(idx);
          }, 120);
        },
        { root: filmstrip, threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] }
      );
      cards.forEach(function (card) {
        observer.observe(card);
      });
      cleanupCallbacks.push(function () { observer.disconnect(); });
    }

    // Playback follows actual visibility throughout the visit, including tab
    // changes. Sound is enabled only through its dedicated control.
    setActive(0);
    if ('IntersectionObserver' in window) {
      var metadataObserver = new IntersectionObserver(function (entries) {
        if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
        requestVideoMetadata(activeIndex);
        metadataObserver.disconnect();
      }, { threshold: 0, rootMargin: '300px 0px' });
      metadataObserver.observe(filmstrip);
      cleanupCallbacks.push(function () { metadataObserver.disconnect(); });

      var visibilityObserver = new IntersectionObserver(function (entries) {
        if (disposed) return;
        isVisible = entries.some(function (entry) { return entry.isIntersecting; });
        if (isVisible) requestVideoMetadata(activeIndex);
        syncPlayback();
      }, { threshold: 0 });
      visibilityObserver.observe(filmstrip);
      cleanupCallbacks.push(function () { visibilityObserver.disconnect(); });
    } else {
      isVisible = true;
      requestVideoMetadata(activeIndex);
      syncPlayback();
    }
    listen(document, 'visibilitychange', syncPlayback);
    listen(motionPreference, 'change', function () {
      if (motionPreference.matches) {
        playbackEnabled = false;
        syncPlayback();
      }
    });
    if (playbackButton) {
      listen(playbackButton, 'click', function () {
        playbackEnabled = !playbackEnabled;
        syncPlayback();
      });
    }

    function setUnmutedUI() {
      if (!soundButton) return;
      soundButton.setAttribute('data-sound-on', '');
      soundButton.setAttribute('aria-pressed', 'true');
      var mutedIcon = soundButton.querySelector('[data-ig-sound-muted]');
      var onIcon = soundButton.querySelector('[data-ig-sound-on]');
      var label = soundButton.querySelector('[data-ig-sound-label]');
      if (mutedIcon) mutedIcon.hidden = true;
      if (onIcon) onIcon.hidden = false;
      if (label) label.textContent = soundButton.dataset.i18nSoundOn || 'Sound On';
    }

    function setMutedUI() {
      if (!soundButton) return;
      soundButton.removeAttribute('data-sound-on');
      soundButton.setAttribute('aria-pressed', 'false');
      var mutedIcon = soundButton.querySelector('[data-ig-sound-muted]');
      var onIcon = soundButton.querySelector('[data-ig-sound-on]');
      var label = soundButton.querySelector('[data-ig-sound-label]');
      if (mutedIcon) mutedIcon.hidden = false;
      if (onIcon) onIcon.hidden = true;
      if (label) label.textContent = soundButton.dataset.i18nSoundOff || 'Tap for Sound';
    }

    function tryUnmute() {
      if (!currentVideo || !currentVideo.muted) return;
      var video = currentVideo;
      playbackEnabled = true;
      video.volume = 0;
      video.muted = false;
      var playResult = video.play();
      if (playResult && typeof playResult.catch === 'function') {
        playResult
          .then(function () {
            if (disposed || video !== currentVideo || !canPlay()) {
              video.pause();
              return;
            }
            fadeVolumeTo(video, UNMUTED_VOLUME, VOLUME_FADE_MS);
            setUnmutedUI();
            syncPlaybackButton();
            startAmbientSampling();
          })
          .catch(function () {
            if (disposed || video !== currentVideo) return;
            // Browser rejected unmuted playback (no user gesture yet, or
            // autoplay-with-sound policy) — fall back to muted autoplay.
            video.muted = true;
            syncPlayback();
            setMutedUI();
          });
      } else {
        fadeVolumeTo(video, UNMUTED_VOLUME, VOLUME_FADE_MS);
        setUnmutedUI();
      }
    }

    if (soundButton) {
      listen(soundButton, 'click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (!currentVideo) return;

        if (currentVideo.muted) {
          tryUnmute();
        } else {
          currentVideo.muted = true;
          setMutedUI();
        }
      });
    }

    // A short shared cooldown across Prev/Next and the arrow keys —
    // double-clicking a button (or holding down an arrow key, which
    // repeats several keydown events a second) used to fire multiple
    // overlapping goToIndex calls before the first one's transition had
    // even really started, each restarting the scroll animation and
    // re-triggering setActive/pause/play on videos in quick succession.
    // That pile-up of overlapping calls was a big part of what read as
    // "buggy" — this makes rapid presses advance one reel at a time
    // instead of stacking.
    var navLocked = false;
    var pendingDelta = 0;
    function navigate(delta) {
      // Bug this fixes: the cooldown used to `return` here, throwing the
      // press away entirely. Clicking Next three times quickly advanced
      // one reel and swallowed the other two, which feels exactly like a
      // button that doesn't work — the cooldown was stopping the animation
      // pile-up it was meant to stop, but at the cost of ignoring input.
      // Banking the delta instead keeps the anti-pile-up behaviour while
      // making every press count: three clicks move three reels, one
      // settled step at a time.
      if (navLocked) {
        pendingDelta += delta;
        return;
      }
      navLocked = true;
      // Starts from nearestIndexToCenter(), not the cached activeIndex —
      // right after a manual swipe, activeIndex can still be one step
      // behind reality until the IntersectionObserver's 120ms debounce
      // catches up. Pressing Next/Prev in that window used to advance
      // from the *old* active card, which could visibly jump to the
      // wrong reel or even seem to go backwards. Reading real geometry
      // here means the button always acts on whatever the visitor is
      // actually looking at right now.
      goToIndex(nearestIndexToCenter() + delta);
      schedule(function () {
        navLocked = false;
        if (pendingDelta !== 0) {
          var queued = pendingDelta;
          pendingDelta = 0;
          navigate(queued);
        }
      }, 250);
    }

    // Prev/Next buttons — see the CSS comment on .ig-reels__nav for why
    // these exist (no other discoverable way for a desktop mouse user to
    // navigate the filmstrip manually).
    var prevButton = section.querySelector('[data-ig-reels-prev]');
    var nextButton = section.querySelector('[data-ig-reels-next]');
    if (prevButton) {
      listen(prevButton, 'click', function () {
        navigate(-1);
      });
    }
    if (nextButton) {
      listen(nextButton, 'click', function () {
        navigate(1);
      });
    }

    // Dots jump straight to a reel. They deliberately bypass navigate()'s
    // cooldown, which exists to stop repeated *relative* steps stacking up
    // — an absolute jump has no such pile-up to guard against, and making
    // someone wait 250ms after tapping a specific dot would feel like the
    // dot missed.
    dots.forEach(function (dot, i) {
      listen(dot, 'click', function () {
        goToIndex(i);
      });
    });

    // Left/Right arrow keys navigate the filmstrip whenever focus is
    // anywhere inside it — keyboard-only users get the same navigation
    // mouse users get from the Prev/Next buttons above.
    listen(filmstrip, 'keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        event.preventDefault();
        navigate(-1);
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        navigate(1);
      }
    });

    initAutoFetch(filmstrip);
  }

  function scan(scope) {
    scope.querySelectorAll('[data-ig-reels-filmstrip]').forEach(initFilmstrip);
  }

  scan(document);
  document.addEventListener('shopify:section:load', function (event) { scan(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll('[data-ig-reels-filmstrip]').forEach(function (filmstrip) {
      if (filmstrip.__igReelsDestroy) filmstrip.__igReelsDestroy();
    });
  });

  /**
   * Auto-fetch: pulls real Reels (newest first) from the merchant's own
   * sync worker (see instagram-worker/README.md) and replaces the curated
   * filmstrip with a real, automatically-updating one. If no endpoint is
   * configured, or the fetch fails/times out/returns nothing usable, this
   * does nothing and the curated fallback (rendered server-side by Liquid,
   * already visible) stays exactly as-is — the section never shows a
   * broken or empty state to a visitor.
   */
  function initAutoFetch(filmstrip) {
    var endpoint = filmstrip.getAttribute('data-auto-fetch-endpoint');
    if (!endpoint) return;

    var reelsToShow = parseInt(filmstrip.getAttribute('data-reels-to-show'), 10) || 6;
    var loadMoreEnabled = filmstrip.getAttribute('data-load-more') === 'true';
    var loadMoreWrap = filmstrip.parentElement
      ? filmstrip.parentElement.querySelector('[data-ig-reels-load-more-wrap]')
      : null;
    var loadMoreButton = loadMoreWrap ? loadMoreWrap.querySelector('[data-ig-reels-load-more]') : null;

    fetchReels(endpoint)
      .then(function (reels) {
        if (!filmstrip.isConnected || !reels || !reels.length) return; // keep curated fallback

        renderDynamicReels(filmstrip, reels, reelsToShow, loadMoreEnabled, loadMoreWrap, loadMoreButton);
      })
      .catch(function () {
        // Expected whenever the worker isn't deployed yet, is briefly
        // unreachable, or Instagram itself is having an outage — keep the
        // curated fallback as-is, no visible error.
      });
  }

  /**
   * Fetches the reels JSON from the sync worker, using a short sessionStorage
   * cache so repeat pageviews in the same browsing session don't re-hit the
   * worker (the underlying data only changes on the worker's own ~30 min
   * cron cycle anyway, so nothing is lost by reusing a recent response).
   */
  function fetchReels(endpoint) {
    var cacheKey = SESSION_CACHE_PREFIX + endpoint;

    try {
      var cachedRaw = sessionStorage.getItem(cacheKey);
      if (cachedRaw) {
        var cached = JSON.parse(cachedRaw);
        if (cached && Array.isArray(cached.reels) && Date.now() - cached.cachedAt < SESSION_CACHE_TTL_MS) {
          return Promise.resolve(normalizeReels(cached.reels));
        }
      }
    } catch (e) {
      // Corrupt/unavailable sessionStorage — fall through to a live fetch.
    }

    var controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
    var timeout = controller ? window.setTimeout(function () { controller.abort(); }, 5000) : null;
    return fetch(endpoint, { signal: controller ? controller.signal : undefined })
      .then(function (response) {
        if (!response.ok) throw new Error('Auto-fetch endpoint returned ' + response.status);
        return response.json();
      })
      .then(function (data) {
        var reels = normalizeReels(data && data.reels);

        try {
          sessionStorage.setItem(cacheKey, JSON.stringify({ reels: reels, cachedAt: Date.now() }));
        } catch (e) {
          // Storage full/unavailable (private browsing, etc.) — non-fatal.
        }

        return reels;
      })
      .finally(function () {
        if (timeout) window.clearTimeout(timeout);
      });
  }

  /**
   * Defensive normalization: sorts newest-first by Instagram's own publish
   * timestamp (even though the worker already does this) and dedupes by id,
   * so a misbehaving or manually-edited endpoint can't produce a broken
   * grid or duplicate cards.
   */
  function normalizeReels(rawReels) {
    if (!Array.isArray(rawReels)) return [];

    var seen = Object.create(null);
    var cleaned = [];
    rawReels.forEach(function (reel) {
      if (!reel || !reel.id || !reel.permalink || !reel.thumbnail_url) return;
      // Only accept normal web links and images from a worker response.
      try {
        if (new URL(reel.permalink).protocol !== 'https:' || new URL(reel.thumbnail_url).protocol !== 'https:') return;
      } catch (error) {
        return;
      }
      if (seen[reel.id]) return;
      seen[reel.id] = true;
      cleaned.push(reel);
    });

    cleaned.sort(function (a, b) {
      return new Date(b.timestamp || 0) - new Date(a.timestamp || 0);
    });

    return cleaned;
  }

  function renderDynamicReels(filmstrip, reels, reelsToShow, loadMoreEnabled, loadMoreWrap, loadMoreButton) {
    var shown = 0;

    filmstrip.classList.add('ig-reels__filmstrip--swapping');

    window.setTimeout(function () {
      if (!filmstrip.isConnected) return;
      if (filmstrip.__igReelsDestroy) filmstrip.__igReelsDestroy();
      var section = filmstrip.closest('.ig-reels');
      if (section) {
        section.querySelectorAll('[data-ig-reels-prev], [data-ig-reels-next], [data-ig-reels-dots], [data-ig-reel-sound], [data-ig-reel-playback]').forEach(function (control) {
          control.hidden = true;
        });
      }
      filmstrip.innerHTML = '';
      filmstrip.scrollLeft = 0;
      filmstrip.classList.remove('ig-reels__filmstrip--swapping');
      filmstrip.classList.add('ig-reels__filmstrip--dynamic');

      function appendBatch() {
        var next = reels.slice(shown, shown + reelsToShow);
        next.forEach(function (reel) {
          filmstrip.appendChild(buildReelCard(reel));
        });
        shown += next.length;

        if (loadMoreWrap && loadMoreButton) {
          var hasMore = loadMoreEnabled && shown < reels.length;
          loadMoreWrap.hidden = !hasMore;
        }
      }

      appendBatch();

      if (loadMoreButton && !loadMoreButton.__igLoadMoreInit) {
        loadMoreButton.__igLoadMoreInit = true;
        loadMoreButton.addEventListener('click', appendBatch);
      }
    }, 200);
  }

  function buildReelCard(reel) {
    var link = document.createElement('a');
    link.className = 'ig-reel ig-reel--dynamic';
    link.href = reel.permalink;
    link.target = '_blank';
    // Intentionally noopener only (not noreferrer) — Instagram's own web
    // client can fail to render for requests with no referrer at all.
    link.rel = 'noopener';

    var img = document.createElement('img');
    img.className = 'ig-reel__thumb';
    img.src = reel.thumbnail_url;
    img.alt = reel.caption ? reel.caption.slice(0, 100) : 'Instagram reel';
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 400;
    img.height = 500;
    link.appendChild(img);

    var play = document.createElement('span');
    play.className = 'ig-reel__play';
    play.setAttribute('aria-hidden', 'true');
    play.innerHTML =
      '<svg viewBox="0 0 24 24" width="18" height="18"><path fill="#fff" d="M8 5v14l11-7z"/></svg>';
    link.appendChild(play);

    if (reel.caption) {
      var caption = document.createElement('span');
      caption.className = 'ig-reel__caption ig-reel__caption--small';
      caption.textContent = reel.caption;
      link.appendChild(caption);
    }

    return link;
  }
})();
